<template>
  <v-dialog max-width="500" v-model="visible" persistent>
    <v-card>
      <!-- Title -->
      <v-card-title class="mb-3">
        {{ $translate('NEW_SHOPPING_LIST_TITLE') }}
      </v-card-title>

      <!-- Message -->
      <v-card-text>
        <v-form ref="listForm" v-model="listFormValid" lazy-validation>
          <v-text-field
            v-model="shoppingListName"
            outlined
            :label="$translate('SHOPPING_LIST_NAME')"
            :rules="requiredRules"
          />
        </v-form>
      </v-card-text>

      <v-card-actions class="pb-3">
        <v-spacer />

        <!-- Cancel button -->
        <v-btn color="secondary" @click="onCancelBtnClick">
          {{ $translate('CANCEL') }}
        </v-btn>

        <!-- Save button -->
        <v-btn color="primary" :loading="savingList" @click="onSaveBtnClick">
          {{ $translate('SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import doRequest from '@/api/dssRequest';
import { requiredRules } from '@/shared/validations_rules';

export default {
  name: 'ShoppingListNewList',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  computed: {
    currentSelectedShoppingList() {
      return this.$store.getters.getCurrentSelectedShoppingList;
    },
    shoppingLists() {
      const lists = this.$store.getters['shoppingList/orders'];
      if (lists == null || lists.length === 0) {
        return [];
      }

      const listsCopy = [];
      lists.forEach((list) => {
        listsCopy.push({
          ShoppingListId: list.ShoppingListId,
          ShoppingListName: list.ShoppingListName,
        });
      });

      return listsCopy;
    },
  },
  data() {
    return {
      requiredRules,
      shoppingListName: '',
      listFormValid: true,
      savingList: false,
    };
  },
  methods: {
    closeDialog() {
      this.$emit('close');
      this.shoppingListName = '';
      this.$refs.listForm.reset();
    },
    onCancelBtnClick() {
      this.closeDialog();
    },
    onSaveBtnClick() {
      if (!this.$refs.listForm.validate()) {
        window.EventBus.fire('activateSnackBar', {
          text: this.$translate('LINDA_FILL_REQUIRED'),
          color: 'warning',
        });
        return;
      }

      this.savingList = true;
      const payload = {
        ShoppingListId: '',
        ShoppingListName: this.shoppingListName,
      };

      doRequest(
        (response) => {
          this.savingList = false;

          if (response.data.ShoppingList != null) {
            this.$store.commit(
              'setCurrentSelectedShoppingList',
              response.data.ShoppingList
            );
          }

          this.$emit('saved');
        },
        () => {
          this.savingList = false;
          window.EventBus.fire('activateSnackBar', {
            text: this.$translate('SAVE_SHOPPING_LIST_ERROR'),
            color: 'error',
          });
        },
        'saveShoppingList',
        this.$store.getters['auth/userName'],
        payload
      );
    },
  },
};
</script>
